export const CONTACT_US_URL =
  'https://docs.shijigroup.com/bundle/Shiji_Enterprise_Platform_Contact_Details/page/CONTACT_DETAILS/concepts/c_shiji_enterprise_platform_contact_support.html';

export const LEGAL_NOTICE_URL = 'https://www.shijigroup.com/terms/legal-notice';

export const PRIVACY_URL = 'https://www.shijigroup.com/privacy-policy';
